import axios from 'axios';

const optInForms = {
  getFormPublic: async ({ campaign_id, form_id, search }) => {
    return axios.get(`/api/v2/campaigns/${campaign_id}/opt_in_forms/${form_id}/public${search}`);
  },
};

export default optInForms;
